import { render, staticRenderFns } from "./mv-wd-canvas.vue?vue&type=template&id=49263eff&scoped=true"
import script from "./mv-wd-canvas.vue?vue&type=script&lang=js"
export * from "./mv-wd-canvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49263eff",
  null
  
)

export default component.exports